/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import ReactJson from 'react-json-view';
import styled from 'styled-components';
import SimplifiedLogsViewer from './SimplifiedLogsViewer'; // 👈 Add this line
import CopyToClipboardButton from './CopyToClipboardButton';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalBox = styled.div`
  background: rgb(30, 30, 30);
  padding: 20px;
  border-radius: 8px;
  min-width: 600px;
  max-height: 90%;
  overflow-y: auto;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
  padding: 10px 20px;
  background-color: rgb(239, 68, 68);
  border: none;
  border-radius: 4px;
  color: black;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-right: 10px;
  width: max-content;
`;

const Title = styled.h2`
  margin-top: 0;
`;
const ToggleButton = styled.button`
  background-color: #4ade80;
  color: black;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  margin-bottom: 1rem;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
`;

const copyContentIcon = {
  cursor: 'pointer',
  alignSelf: 'flex-end',
  color: '#fff'
};

const LogsViewer = ({ isOpen, onClose, jsonData, logType, simplifiedLogs }) => {
  const modalRef = useRef();
  const [showSimplified, setShowSimplified] = useState(false);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <Overlay onClick={handleClickOutside}>
      <ModalBox ref={modalRef}>
        <CloseButton onClick={onClose}>Close</CloseButton>
        <Title>{logType}</Title>

        {logType === 'Execution Log' && (
          <ToggleButton onClick={() => setShowSimplified((prev) => !prev)}>
            {showSimplified ? 'Show Raw Logs' : 'Show Simplified Logs'}
          </ToggleButton>
        )}

        {showSimplified ? (
          <Row>
            <CopyToClipboardButton valueToCopy={simplifiedLogs} iconStyle={copyContentIcon} />{' '}
            <SimplifiedLogsViewer logText={simplifiedLogs} />
          </Row>
        ) : (
          <ReactJson
            src={jsonData}
            style={{ backgroundColor: 'rgb(30, 30, 30)' }}
            collapsed={1}
            theme="monokai"
            displayDataTypes={false}
          />
        )}
      </ModalBox>
    </Overlay>
  );
};

export default LogsViewer;
